var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHotTopicBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64088 1.70097C8.60071 1.64713 8.5501 1.60194 8.49207 1.5681C8.43404 1.53425 8.36979 1.51245 8.30314 1.50398C8.2365 1.49552 8.16884 1.50057 8.10419 1.51884C8.03954 1.53711 7.97924 1.56822 7.92688 1.61031C6.64925 2.63602 5.8065 4.10673 5.56755 5.72764C5.12967 5.41011 4.74585 5.02404 4.43089 4.58431C4.38811 4.52451 4.33266 4.47488 4.26851 4.43896C4.20436 4.40304 4.13307 4.38171 4.05973 4.37649C3.98639 4.37127 3.9128 4.38228 3.84421 4.40876C3.77562 4.43523 3.7137 4.4765 3.66289 4.52964C2.78243 5.45068 2.21805 6.62809 2.05149 7.89133C1.88493 9.15457 2.12485 10.438 2.73648 11.5558C3.34812 12.6736 4.29971 13.5676 5.45342 14.1084C6.60713 14.6492 7.90305 14.8087 9.15346 14.5637C10.4039 14.3188 11.5438 13.6821 12.4082 12.746C13.2726 11.8099 13.8165 10.6229 13.9612 9.35693C14.1059 8.091 13.8438 6.81188 13.2129 5.70486C12.582 4.59784 11.6151 3.7204 10.4522 3.19964C9.73735 2.85202 9.11622 2.33811 8.64088 1.70097ZM10.4989 9.67697C10.4986 10.0386 10.4199 10.3959 10.2682 10.7241C10.1165 11.0524 9.89538 11.3438 9.62011 11.5783C9.34483 11.8128 9.02196 11.9848 8.67377 12.0824C8.32557 12.1801 7.96034 12.201 7.60328 12.1437C7.24621 12.0865 6.90581 11.9525 6.60556 11.751C6.30531 11.5494 6.05236 11.2852 5.86415 10.9764C5.67595 10.6676 5.55697 10.3216 5.51543 9.96242C5.4739 9.60319 5.51078 9.23923 5.62355 8.89564C6.04222 9.20564 6.52355 9.43564 7.04555 9.56231C7.18708 8.64961 7.6406 7.81419 8.32889 7.19831C8.92956 7.2783 9.48073 7.57373 9.87989 8.02967C10.279 8.4856 10.499 9.071 10.4989 9.67697Z",
    fill: "url(#paint0_linear_7218_39125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7218_39125",
    x1: 8.00001,
    y1: 1.5,
    x2: 8.00001,
    y2: 14.6757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4242"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHotTopicBadge);
export default __webpack_public_path__ + "static/media/icon-hot-topic-badge.d2b2a03c2d111115f3b99c86c126dbee.svg";
export { ForwardRef as ReactComponent };